export default "__VITE_ASSET__BO3ny__y__"